import { baseApi } from '@/lib/api/baseApi';

import type { Builder } from '../commonApiType/apiBuilderTypes';

export const changePasswordApi = baseApi.injectEndpoints({
  endpoints: (builder: Builder) => ({
    changePassword: builder.mutation({
      query: credentials => ({
        url: '/appmanagement/optimize/v1/public/user/change-password',
        method: 'POST',
        body: credentials,
      }),
      transformResponse: response => response,
      invalidatesTags: [{ type: 'Users', id: 'LIST' }],
    }),
  }),
  overrideExisting: 'throw',
});
